import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { automationService } from '../../services/automationService';

const AdminSampleAutomationCreator: React.FC = () => {
  const { currentUser } = useAuth();
  const { showSuccess, showError } = useNotification();

  const [workspaceId, setWorkspaceId] = useState<string>('');
  const [automationName, setAutomationName] = useState<string>('Sample: Added to cart');
  const [loading, setLoading] = useState<boolean>(false);

  const handleCreate = async () => {
    if (!currentUser) {
      showError('You must be logged in as admin.');
      return;
    }
    if (!workspaceId) {
      showError('Please enter a workspace ID.');
      return;
    }

    setLoading(true);
    try {
      const steps = [
        {
          id: 'trigger-1',
          type: 'trigger' as const,
          title: 'Added product to cart',
          description: 'Starts when a product is added to cart',
          config: {
            type: 'added_product_to_cart',
            skipAlreadyIn: true,
            triggerFilters: []
          },
          position: { x: 100, y: 50 },
          connections: ['email-1'],
          enabled: true
        },
        {
          id: 'email-1',
          type: 'action' as const,
          title: 'Send email: Cart follow-up',
          description: 'Send a quick follow-up email',
          config: {
            type: 'send_email',
            subject: 'You left something in your cart',
            fromName: 'Store Team',
            fromEmail: 'no-reply@scubamail.local',
            replyTo: 'support@scubamail.local'
          },
          position: { x: 100, y: 200 },
          connections: [],
          enabled: true
        }
      ];

      const automationData: any = {
        name: automationName,
        description: 'Sample automation generated by Admin tool',
        status: 'active' as const,
        userId: currentUser.uid,
        workspaceId,
        steps,
        settings: {
          allowRepetition: true,
          openTracking: true,
          clickTracking: true,
          personalizedToField: false,
          googleAnalyticsTracking: false
        },
        statistics: {
          totalRuns: 0,
          successfulRuns: 0,
          failedRuns: 0,
          contactsProcessed: 0,
          emailsSent: 0
        }
      };

      const id = await automationService.createAutomation(automationData);
      showSuccess(`Sample automation created and activated (ID: ${id})`);
    } catch (err) {
      console.error(err);
      showError('Failed to create sample automation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-gray-200 dark:border-neutral-700 rounded-lg p-4 bg-white dark:bg-neutral-800">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Create & activate sample automation</h3>
        <span className="text-xs px-2 py-0.5 rounded bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">Quick start</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <input
          value={workspaceId}
          onChange={(e) => setWorkspaceId(e.target.value)}
          placeholder="Workspace ID"
          className="px-3 py-2 border rounded-md bg-white dark:bg-neutral-900 border-gray-300 dark:border-neutral-700 text-sm"
        />
        <input
          value={automationName}
          onChange={(e) => setAutomationName(e.target.value)}
          placeholder="Automation name"
          className="px-3 py-2 border rounded-md bg-white dark:bg-neutral-900 border-gray-300 dark:border-neutral-700 text-sm"
        />
        <button
          onClick={handleCreate}
          disabled={loading}
          className="px-4 py-2 rounded-md bg-black text-white hover:bg-gray-800 disabled:opacity-50 text-sm"
        >
          {loading ? 'Creating…' : 'Create & activate (Added to cart)'}
        </button>
      </div>
      <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">Trigger: Added product to cart • No filters • Sends one follow-up email.</p>
    </div>
  );
};

export default AdminSampleAutomationCreator;



























































